import { PiccDetectEnum } from './picc-detect-enum';
import { SmartCardStateEnum } from './smart-card-state-enum';
import { StatusConnectionEnum } from './status-connection-enum';

export class SmartCardStatus {
  status: StatusConnectionEnum;
  statusCode: number;
  cardStackIsEmpty: boolean;
  state: SmartCardStateEnum;
  cardUID: string;
  isDispenserOnInitPos: boolean;
  isCardReadEmpty: boolean;
  isCardDetected: boolean;
  isCardInserted: boolean;
  isCardTaken: boolean;
  isCardMade: boolean;
  isCardReleased: boolean;
  isCardStackEmpty: boolean;
  isCardNearContactlessReader: boolean;
  piccDetectState: PiccDetectEnum;

  constructor(
    status: StatusConnectionEnum,
    statusCode: number,
    cardStackIsEmpty: boolean,
    state: SmartCardStateEnum,
    cardUID: string,
    isDispenserOnInitPos: boolean,
    isCardReadEmpty: boolean,
    isCardDetected: boolean,
    isCardInserted: boolean,
    isCardTaken: boolean,
    isCardMade: boolean,
    isCardReleased: boolean,
    isCardStackEmpty: boolean,
    isCardNearContactlessReader: boolean,
    piccDetect: PiccDetectEnum
  ) {
    this.status = status;
    this.statusCode = statusCode;
    this.cardStackIsEmpty = cardStackIsEmpty;
    this.state = state;
    this.cardUID = cardUID;
    this.isDispenserOnInitPos = isDispenserOnInitPos;
    this.isCardReadEmpty = isCardReadEmpty;
    this.isCardDetected = isCardDetected;
    this.isCardInserted = isCardInserted;
    this.isCardTaken = isCardTaken;
    this.isCardMade = isCardMade;
    this.isCardReleased = isCardReleased;
    this.isCardStackEmpty = isCardStackEmpty;
    this.isCardNearContactlessReader = isCardNearContactlessReader;
    this.piccDetectState = piccDetect;
  }

  static createFromAny(object: any): SmartCardStatus {
    if (!object) {
      return null;
    }

    const parsedStatusConnection = object.status as StatusConnectionEnum;
    const parsedPiccDetect = object.picc_detect as PiccDetectEnum;
    const switchStat1 = object.switch_stat1 as number;
    const switchStat2 = object.switch_stat2 as number;
    const switchStatValue = ((switchStat1 * 0x100) + switchStat2) as SmartCardStateEnum;

    return new SmartCardStatus(
      parsedStatusConnection,
      object.status_code,
      object.card_stack_is_empty,
      switchStatValue,
      object.card_uid,
      object.is_dispenser_on_init_pos,
      object.is_card_read_empty,
      object.card_detected,
      object.card_inserted,
      object.is_card_taken,
      object.is_card_made,
      object.is_card_released,
      object.is_card_stack_empty,
      object.is_card_near_contactless_reader,
      parsedPiccDetect
    );
  }

  get isCardAvailable(): boolean {
    return this.status === StatusConnectionEnum.Connected && (!this.isCardStackEmpty || this.isCardInserted);
  }
}
